const getResponseByParams = (params, options) => {
  const optionsBody = JSON.parse(options.body);
  let statusCode = '000';

  /**
   * If submitted date is 1970-01-01 return date mismatch error.
   */
  if (optionsBody.dateOfBirth === '1970-01-01') {
    statusCode = '210';
  }

  /**
   * If password is 'recaptcha' return reCaptcha token error.
   */
  if (optionsBody.password === 'recaptcha') {
    statusCode = '1000';
  }

  return {
    statusCode: statusCode,
    error: {
      context: {
        statusCode
      }
    }
  };
};

export default {
  options: {
    minDelay: 500,
    maxDelay: 2000,
    failRate: 0
  },
  onFetching: getResponseByParams
};
